import { render, staticRenderFns } from "./FooterContacts.vue?vue&type=template&id=ba836280&scoped=true&"
import script from "./FooterContacts.vue?vue&type=script&lang=js&"
export * from "./FooterContacts.vue?vue&type=script&lang=js&"
import style0 from "./FooterContacts.vue?vue&type=style&index=0&id=ba836280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba836280",
  null
  
)

export default component.exports